export default {
    resetState({commit}) {
        commit('resetStateMutation');
    }
}